import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IVideoStudiosContext, VideoStudiosContext } from '../../videoStudiosState/videoStudiosContext';
import Item from './components/Item';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import classNames from 'classnames';
import style from './VideoStudios.module.scss';

const VideoStudios: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, videoStudios, currentPage, countOfItems } =
		useContext<IVideoStudiosContext>(VideoStudiosContext);
	const nameHeadingClasses = classNames(style.name, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<>
			{videoStudios.videoStudiosCount ? (
				<div className={style.container} data-test="VideoStudios">
					<div className={style.tableHeaders}>
						<Text
							className={nameHeadingClasses}
							translationNameSpace="listing"
							translationKey="nameLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
						<Text
							className={actionHeadingClasses}
							translationNameSpace="listing"
							translationKey="actionLabel"
							theme="neutralLight"
							withTooltip={true}
						/>
					</div>
					{videoStudios.videoStudios.map((item, index) => (
						<Item data={item} key={item.id} index={index} />
					))}
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={videoStudios.videoStudiosCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};

export default VideoStudios;
